import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import i18n from "../../i18n/i18n";
const BASE_URL = process.env.REACT_APP_BASE_URL;

// all rental main projects
export const fetchRentalMainProjects = createAsyncThunk(
  "rental_projects_main/fetchAll",
  async ({ page = 1, filters = {} } = {}, { rejectWithValue }) => {
    try {
      const queryParams = new URLSearchParams();
      queryParams.append("page", page);
      
      // Add filters to query params
      if (filters.project_number) {
        queryParams.append("project_number", filters.project_number);
      }
      if (filters.project_id) {
        queryParams.append("project_id", filters.project_id);
      }
      if (filters.client_type) {
        queryParams.append("client_type", filters.client_type);
      }
      if (filters.client_id) {
        queryParams.append("client_id", filters.client_id);
      }

      const response = await axios.get(`${BASE_URL}/rental-main/projects?${queryParams.toString()}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "application/json",
          Lang: i18n.language,
        },
      });
      return response.data; // Return the whole response including pagination
    } catch (error) {
      const message = error.response?.data?.message || "Failed load data";
      return rejectWithValue(message);
    }
  }
);


// add rental main projects
export const addRentalMainProjects = createAsyncThunk(
  "rental_projects_main/add",
  async (userData, { rejectWithValue }) => {
    try {
      const response = await axios.post(`${BASE_URL}/rental-main/projects/add`, userData, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "application/json",
          Lang: i18n.language,
        },
      });
      return response.data;
    } catch (error) {
      const message =
        error.response?.data?.message || "An unknown error occurred";
      return rejectWithValue(message);
    }
  }
);

const RentalMainProjectsSlice = createSlice({
  name: "rental_projects_main",
  initialState: {
    rental_projects_main: [],
    record: null,
    isLoading: false,
    error: null,
    success: null,
    successDelete: null,
    errorDelete: null,
    pagination: null,
  },
  reducers: {
    clearState: (state) => {
      state.error = null;
      state.success = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchRentalMainProjects.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchRentalMainProjects.fulfilled, (state, action) => {
        state.isLoading = false;
        state.rental_projects_main = action.payload.data.data;
        state.pagination = action.payload.data.pagination;
      })
      .addCase(fetchRentalMainProjects.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload || "Failed to load data";
      })
      .addCase(addRentalMainProjects.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(addRentalMainProjects.fulfilled, (state, action) => {
        state.isLoading = false;
        state.success = action.payload.message;
      })
      .addCase(addRentalMainProjects.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload || "Failed to add data";
      });
  },
});

export const { clearState } = RentalMainProjectsSlice.actions;
export default RentalMainProjectsSlice.reducer;
